module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Optional":"Optional"},"fr":{"Optional":"Optionnel"}}')
  delete Component.options._Ctor
}
